import { Feature } from '@/config/features'
import { useHasFeature } from '@/hooks/useHasFeature'
import { useOptionalUser } from '@/pages/user/selectors'
import { isInternalDuprEmail } from './useCanUseClubCapabilities'

/**
 * Client-side gate for the club "coaching" surface — the coach-facing tools (read-only
 * member info plus capability actions like rating tuning). Internal DUPR staff always
 * get it for dogfooding; the Coaching remote-config flag controls general availability
 * until GA, so the whole surface (the row affordance and the in-member action card) stays
 * hidden for everyone else.
 *
 * The server is still the final gate: it only exposes a club's coaching capability and its
 * member actions to viewers who hold the permission, so the UI renders nothing on a club
 * without the capability — or for a non-coach — regardless of this hook.
 */
export const useCanUseCoaching = (): boolean => {
  const generallyAvailable = useHasFeature(Feature.Coaching)
  const user = useOptionalUser()
  return isInternalDuprEmail(user?.email) || generallyAvailable
}
